export const filterConfig = [{
  id: 'NomeOperacao',
  type: 'text',
  label: 'Nome da Operação',
  placeholder: 'Digite o nome da operação'
}, {
  id: 'TipoDaOperacao',
  type: 'text',
  label: 'Tipo da Operação',
  placeholder: 'Digite o tipo da operação'
}, {
  id: 'Situacao',
  type: 'select',
  label: 'Situação',
  placeholder: 'Selecione...',
  options: [{
    value: 'Ativo',
    label: 'Ativo'
  }, {
    value: 'Inativo',
    label: 'Inativo'
  }]
}, {
  id: 'GerarCobranca',
  type: 'select',
  label: 'Gerar Cobrança',
  placeholder: 'Selecione...',
  options: [{
    value: '1',
    label: 'Sim'
  }, {
    value: '0',
    label: 'Não'
  }]
}];
